import styled from "styled-components"

export const Wrapper = styled.div`
  position: relative;
  font-family: var(--averta-regular), sans-serif;
  color: var(--black);
  order: ${({ order }) => order};
  background: #ffffff;
  cursor: pointer;
  transition: transform ease 0.25s, box-shadow ease 0.25s;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  grid-column: span ${({ type }) => (type === "important" ? 2 : 1)};
  grid-row: span ${({ type }) => (type === "important" ? 2 : 2)};
  border-radius: 10px;
  overflow: hidden;

  &:hover {
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);
    transform: translateY(-5px);
  }

  &:focus {
    box-shadow: 0 0 0 2pt var(--blue);
    outline: none;
  }

  & > section {
    height: 100%;
    width: 100%;
    border-radius: 6px;
  }
`

export const InnerWrapper = styled.div`
  height: 100%;
  width: 100%;

  & > h3 {
    float: right;
    width: auto;
    padding: 7px 8px 9px 8px;
    margin: 5px;
    background-color: white;
    border-radius: 8px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));

    ${({ theme }) => theme.mq.atTablet`
        padding: 10px;
    `}

    & > span:nth-child(1) {
      ${({ theme }) => theme.text.smallSemiBold}/* margin-right: 5px; */
    }
    & > span:nth-child(2) {
      ${({ theme }) => theme.text.tinySemiBold}
      color: var(--grey);
    }
  }

  & > ul {
    display: flex;
    align-items: flex-end;
    align-content: flex-end;

    height: 100%;
    margin: 0;
    padding: 0;
  }

  & > span {
    position: absolute;
    bottom: -5px;
    right: 0;
    height: 40px;
    width: 40px;
    color: white;
  }
`
